import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emailNotificationRecipient',
    pure: true,
    standalone: false,
})
export class EmailNotificationRecipientPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        switch (value) {
            case 'end_user':
                return 'End user';
            case 'coach':
                return 'Coach';
            default:
                return value ?? '';
        }
    }
}
